import React, { useRef } from 'react';
import './action-items-list-table.styles.scss';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import { properCase } from '@/utils/properCase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';

const ActionItemsListTable = ({
  gameData,
  gameElements,
  actionItemsToDisplay,
  playerList,
  goToTransaction,
  view
}) => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const countRef = useRef(0);
  const navigate = useNavigate();

  return (
    <div className="action-items-list-table">
      <table className='g-table'>
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>Name</th>
            <th>Action</th>
            {
              (screenSize !== 'mobile') &&
              <>
              <th>Element</th>
              <th>Submitted</th>
              </>
            }
            {
              (view === 'completed') &&
              <th>Status</th>
            }
            <th></th>
          </tr>
        </thead>
        <tbody>
          {
            (
              actionItemsToDisplay &&
              playerList &&
              gameElements &&
              Object.values(actionItemsToDisplay).length > 0
            ) &&
            Object.values(actionItemsToDisplay).map((item, index) => {
              if (index === 0 || countRef.current === 0) {
                countRef.current = 0;
              }
              const player = playerList[item.playerId];
              if (!player) return null;
              const element = gameElements[item.elementId];
              if (!element) return null;
              
              countRef.current++;
              return (
                <tr key={item.id}>
                  <td>{countRef.current}</td>
                  <td className='icon'>
                    <UserIcon
                      profile={player}
                      small={true}
                    />
                  </td>
                  <td>
                    {player.lName}, {player.fName}
                  </td>
                  <td>
                    {item.event}
                  </td>
                  {
                    (screenSize !== 'mobile') &&
                    <>
                    <td className='element'>
                      <div className='icon'>
                        <ImageContainer 
                          src={element.icon} 
                          alt={`${element.name} icon`}
                          containerHeight='2.5rem'
                          containerWidth='2.5rem' />
                      </div>
                      {element.name} {item.quantity && <span>(x{item.quantity})</span>}
                    </td>
                    <td>
                        {format(new Date(item.ts_submitted), "Pp")}
                    </td>
                    </>
                  } 
                  <td>
                  {
                    (view === 'completed') &&
                    <div>{properCase(item.status)}</div>
                  }
                  </td>
                  <td>
                    <button 
                        className='g-button small-btn' 
                        onClick={() => goToTransaction(item)}
                    >
                        <FontAwesomeIcon
                            icon={faArrowRight} 
                            size='xl' 
                        />
                    </button>
                  </td>  
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  )
}

export default ActionItemsListTable